window.addEventListener('load', () => {
    scrollToTop();
});

window.addEventListener('resize', () => {
});

function scrollToTop() {
    const buttonScroll = document.querySelector('[data-scroll-to-top]');

    buttonScroll.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    });
}